<template>
    <v-chip
        v-bind="$attrs"
        :color="current?.color"
        :dark="current?.dark"
    >
        <v-tooltip
            bottom
            v-if="tooltip"
        >
            <template #activator="{ on, attrs }">
                <span
                    class="text-truncate"
                    v-bind="attrs"
                    v-on="on"
                >
                    {{ current?.text || value }}
                </span>
            </template> 
            <span>{{ current?.text || value }}</span>
        </v-tooltip>

        <span
            v-else
            class="text-truncate"
        >
            {{ current?.text || value }}
        </span>
    </v-chip>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: null
        },
        items: {
            type: Array,
            default: () => []
        },
        tooltip: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        current(){
            return this.items.find(item => item.value === this.value)
        }
    }
}

</script>
